module.exports = __webpack_public_path__ + "img/invest1.915eeaea.jpeg";